import { render, staticRenderFns } from "./AdminNoticeItem.vue?vue&type=template&id=2996927e"
import script from "./AdminNoticeItem.vue?vue&type=script&lang=js"
export * from "./AdminNoticeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports